export default __webpack_public_path__ + "static/media/uploadevaluation.0c112adb.svg";